import { Action } from '@appTypes/Action';
import { DataExportCount } from '@appTypes/DataExport';
import { DealerInfo } from '@appTypes/DealerInfo';
import { DealerServices, Services } from '@appTypes/DealerServices';
import { FeatureToggle } from '@appTypes/FeatureToggle';
import { IPitchStatusState } from '@appTypes/PitchStatus';
import { SalesPerson } from '@appTypes/SalesPerson';

export enum DealerActionType {
  SET_SALES_PERSONS = 'Set Sales Persons',
  SET_DEALER_INFO = 'SET_DEALER_INFO',
  SET_DEALER_INFOS = 'SET_DEALER_INFOS',
  SET_PITCH_STATUS = 'Set Pitch Status',
  SET_FEATURE_TOGGLE = 'Set Feature Toggle',
  SET_SELECTED_PITCH_STATUS = 'Set Selected Pitch Status',
  SET_DEALER_SERVICES = 'Set Dealer Active Services',
  SET_STORE_SERVICES = 'Set Store Active Services',
  SET_CAR_FAX_ADVANTAGE_STATUS = 'SET_CAR_FAX_ADVANTAGE_STATUS',
  SET_CONQUEST_STATUS = 'SET_CONQUEST_STATUS',
  SET_TURN_STATUS = 'SET_TURN_STATUS',
  SET_TRANSUNION_STATUS = 'SET_TRANSUNION_STATUS',
  SET_PREOWNED_STATUS = 'SET_PREOWNED_STATUS',
  SET_USER_API_KEY = 'SET_USER_API_KEY',
  SET_CAR_FAX_STATUS = 'SET_CAR_FAX_STATUS',
  SET_SEND_VIDEO_STATUS = 'SET_SEND_VIDEO_STATUS',
  SET_ROOFTOP_STATUS = 'SET_ROOFTOP_STATUS',
  SET_IS_LOGGED_INTO_CARFAX = 'SET_IS_LOGGED_INTO_CARFAX',
  SET_CARFAX_SNAPSHOTKEY = 'SET_CARFAX_SNAPSHOTKEY',
  SET_CARFAX_SNAPSHOTKEY_FOR_REPLACEMENT = 'SET_CARFAX_SNAPSHOTKEY_FOR_REPLACEMENT',
  SET_CARFAX_SNAPSHOTKEY_ERROR = 'SET_CARFAX_SNAPSHOTKEY_ERROR',
  SET_CARFAX_SNAPSHOTKEY_ERROR_FOR_REPLACEMENT = 'SET_CARFAX_SNAPSHOTKEY_ERROR_FOR_REPLACEMENT',
  SET_SHOW_PRIVATEINCENTIVE_DIALOG = 'SET_SHOW_PRIVATEINCENTIVE_DIALOG',
  SET_CURRENT_PAGE_URL = 'SET_CURRENT_PAGE_URL',
  SET_PRIVATE_INCENTIVE_COUNT = 'SET_PRIVATE_INCENTIVE_COUNT',
  SET_EEQ_CONQUEST_PRIVATE_INCENTIVE_COUNT = 'SET_EEQ_CONQUEST_PRIVATE_INCENTIVE_COUNT',
  SET_HAS_CPO = 'SET_HAS_CPO',
  SET_IS_LOADING_DEALER = 'SET_IS_LOADING_DEALER',
  SET_IS_CRM_PAGE_AVAILABLE = 'SET_IS_CRM_PAGE_AVAILABLE',
}

export const setSalesPersons = (salesPersons: SalesPerson[]): Action => ({
  type: DealerActionType.SET_SALES_PERSONS,
  payload: salesPersons,
});

export const setDealerInfoAction = (dealerInfo: DealerInfo): Action => ({
  type: DealerActionType.SET_DEALER_INFO,
  payload: dealerInfo,
});

export const setDealerInfosAction = (dealerInfos: DealerInfo[]): Action => ({
  type: DealerActionType.SET_DEALER_INFOS,
  payload: dealerInfos,
});

export const setCarFaxAdvantageStatusAction = (value: boolean): Action => ({
  type: DealerActionType.SET_CAR_FAX_ADVANTAGE_STATUS,
  payload: value,
});

export const setConquestStatusAction = (value: boolean): Action => ({
  type: DealerActionType.SET_CONQUEST_STATUS,
  payload: value,
});

export const setTurnStatusAction = (value: boolean): Action => ({
  type: DealerActionType.SET_TURN_STATUS,
  payload: value,
});

export const setTransUnionStatusAction = (value: boolean): Action => ({
  type: DealerActionType.SET_TRANSUNION_STATUS,
  payload: value,
});

export const setSendVideoAction = (value: boolean): Action => ({
  type: DealerActionType.SET_SEND_VIDEO_STATUS,
  payload: value,
});

export const setPreownedStatusAction = (value: boolean): Action => ({
  type: DealerActionType.SET_PREOWNED_STATUS,
  payload: value,
});

export const setUserApiKeyAction = (value: string): Action => ({
  type: DealerActionType.SET_USER_API_KEY,
  payload: value,
});

export const setCarFaxStatusAction = (value: boolean): Action => ({
  type: DealerActionType.SET_CAR_FAX_STATUS,
  payload: value,
});

export const setRooftopAction = (value: boolean): Action => ({
  type: DealerActionType.SET_ROOFTOP_STATUS,
  payload: value,
});

export const setIsLoggedIntoCarFaxAction = (value: boolean): Action => ({
  type: DealerActionType.SET_IS_LOGGED_INTO_CARFAX,
  payload: value,
});

export const setCarFaxSnapshotkeyAction = (value: string): Action => ({
  type: DealerActionType.SET_CARFAX_SNAPSHOTKEY,
  payload: value,
});

export const setCarFaxSnapshotkeyForReplacementAction = (value: string): Action => ({
  type: DealerActionType.SET_CARFAX_SNAPSHOTKEY_FOR_REPLACEMENT,
  payload: value,
});

export const setCarFaxSnapshotkeyErrorAction = (value: string): Action => ({
  type: DealerActionType.SET_CARFAX_SNAPSHOTKEY_ERROR,
  payload: value,
});

export const setCarFaxSnapshotkeyErrorForReplacementAction = (value: string): Action => ({
  type: DealerActionType.SET_CARFAX_SNAPSHOTKEY_ERROR_FOR_REPLACEMENT,
  payload: value,
});

export const setShowPrivateIncentiveDialogDealsheet = (value: boolean): Action => ({
  type: DealerActionType.SET_SHOW_PRIVATEINCENTIVE_DIALOG,
  payload: value,
});

export const setCurrentPageUrl = (value: string): Action => ({
  type: DealerActionType.SET_CURRENT_PAGE_URL,
  payload: value,
});

export const setPitchStatus = (pitchStatus: IPitchStatusState[]): Action => ({
  type: DealerActionType.SET_PITCH_STATUS,
  payload: pitchStatus,
});

export const setSelectedPitchStatus = (selectedPitchStatus: IPitchStatusState): Action => ({
  type: DealerActionType.SET_SELECTED_PITCH_STATUS,
  payload: selectedPitchStatus,
});

export const setFeatureToggle = (featureToggle: FeatureToggle): Action => ({
  type: DealerActionType.SET_FEATURE_TOGGLE,
  payload: featureToggle,
});

export const setDealerServices = (dealerServices: Array<DealerServices>): Action => ({
  type: DealerActionType.SET_DEALER_SERVICES,
  payload: dealerServices,
});

export const setStoreServices = (storeServices: Services): Action => ({
  type: DealerActionType.SET_STORE_SERVICES,
  payload: storeServices,
});

export const SetPrivateIncentiveCount = (payload: DataExportCount): Action => ({
  type: DealerActionType.SET_PRIVATE_INCENTIVE_COUNT,
  payload: payload,
});

export const SetEEQConquestPrivateIncentiveCount = (payload: DataExportCount): Action => ({
  type: DealerActionType.SET_EEQ_CONQUEST_PRIVATE_INCENTIVE_COUNT,
  payload: payload,
});

export const setIsCpo = (value: boolean): Action => ({
  type: DealerActionType.SET_HAS_CPO,
  payload: value,
});

export const setIsLoadingDealer = (value: boolean): Action => ({
  type: DealerActionType.SET_IS_LOADING_DEALER,
  payload: value,
});

export const setIsCrmPageAvailable = (value: boolean): Action => ({
  type: DealerActionType.SET_IS_CRM_PAGE_AVAILABLE,
  payload: value,
});

export type DealerActions = ReturnType<
  | typeof setSalesPersons
  | typeof setDealerInfosAction
  | typeof setPitchStatus
  | typeof setSelectedPitchStatus
  | typeof setFeatureToggle
  | typeof setDealerServices
  | typeof setStoreServices
  | typeof SetPrivateIncentiveCount
  | typeof SetEEQConquestPrivateIncentiveCount
  | typeof setIsLoadingDealer
  | typeof setIsCrmPageAvailable
>;
